<script setup>
  import { computed, onMounted, useTemplateRef, ref } from 'vue'
  import StepListItem from '@/components/Study/StepListItem.vue'
  import StepCurriculumItem from '@/components/Study/StepCurriculumItem.vue'
  import { useEventsStore } from '@/stores/events'
  import { storeToRefs } from 'pinia'
  import { useMediaQuery } from '@vueuse/core'

  const itemWrapper = useTemplateRef('itemWrapper')
  const stepListWrapper = useTemplateRef('stepListWrapper')
  const index = ref(null)

  const isActive = ref(false)
  const isLargeScreen = useMediaQuery('(min-width: 1024px)')

  const eventStore = useEventsStore()
  const { isCurriculum } = storeToRefs(eventStore)

  const props = defineProps({
    headline: String,
    text: String,
    items: String
  })

  const items = computed(() => {
    if (!props.items) return false

    const items = JSON.parse(props.items)

    if (!items || items.length < 1) return false

    return items
  })

  onMounted(() => {
    const parentNode = itemWrapper.value.parentNode

    if (!parentNode) return false

    index.value = parentNode.getAttribute('data-index')
    if (index.value == '0') isActive.value = true
  })

  const wrapperHeight = computed(() => {
    if (!stepListWrapper.value) return

    if (!isActive.value && !isLargeScreen.value) {
      return '0px'
    }

    if (isLargeScreen.value) return 'auto'

    return stepListWrapper.value.scrollHeight + 20 + 'px'
  })

</script>

<template>
  <div
    ref="itemWrapper"
    class="step-list-item-number -mt-2 lg:col-start-2 col-span-2 lg:col-span-1 ~text-4xl/6xl text-body opacity-60"
  >
    {{ index }}
  </div>
  <div
    class="step-list-item-headline col-span-4 hidden lg:block ~text-xl/2xl text-headline"
    v-html="headline"
  />
  <div
    class="step-list-item-details col-span-8 lg:col-span-6"
  >
    <div
      class="mobile-headline flex lg:hidden flex-row items-center justify-between ~text-lg mb-3 text-headline"
      @click="isActive = !isActive"
    >
      <span
        v-html="headline"
      />
      <AppIcon
        name="Chevron"
        class="transition-transform duration-500 ease-in-out"
        :class="{ 'rotate-180': isActive }"
      />
    </div>
    <div
      class="step-list-item-details-wrapper overflow-hidden transition-all duration-500 ease-in-out"
      ref="stepListWrapper"
      :style="{ maxHeight: `${wrapperHeight}` }"
    >
      <div
        class="details-top"
        v-html="text"
      />
      <div
        v-if="items && !isCurriculum"
        class="details-list flex flex-col"
      >
        <StepListItem
          v-for="(item, index) in items"
          :index="index"
          :item="item"
        />
      </div>
      <div
        v-else-if="items && isCurriculum"
        class="details-list flex flex-col"
      >
        <StepCurriculumItem
          v-for="(item, index) in items"
          :index="index"
          :item="item"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mobile-headline {
  :deep(svg) {
    @apply h-4 w-4;
  }
}
</style>
